import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import mediaQueries from "../../../../util/mediaqueries";
import { spacing } from "../../../../util/spacing";
import styled, { css } from 'styled-components';
import Button from "../../../button/button";
export var RightNavigationContainer = styled.div.withConfig({
  componentId: "sc-192z6m8-0"
})(["display:flex;justify-content:flex-end;align-items:center;flex-grow:1;gap:", ";", " z-index:1;"], spacing(2), mediaQueries.md(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-grow: unset;\n  "]))))));
export var HighlightedMobileLink = styled(Button).withConfig({
  componentId: "sc-192z6m8-1"
})(["visibility:hidden;opacity:0;transition:opacity 200ms ease-in-out,visibility 200ms ease-in-out;", " ", ""], function (_ref) {
  var isVisible = _ref.isVisible;
  return isVisible && css(["visibility:visible;opacity:1;"]);
}, mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: none;\n  "]))))));